// @ts-nocheck: converted from JS

import TaskTemplatesCreate from '@/components/Tasks/Templates/Create';

export default TaskTemplatesCreate;
